<div class="impact-item-wrapper">
  <div class="impact-item" (click)="openMetricsInfoModal(metric.name)" *ngFor="let metric of impactMetrics">
    <div class="flex">
      <div class="impact-item__left">
        <div class="title">
          <b>
            {{ metric.value.toFixed(0) | thousand }}
            <span>{{ metric.units }}</span>
          </b>
          <br />
          {{ 'INSIGHTS.metrics.' + metric.name | translate }}
        </div>
        <p class="note">{{ 'INSIGHTS.metrics.note.' + metric.name | translate: { number: metric.value.toFixed(0) | thousand } }}</p>
      </div>
      <div class="impact-item__right">
        <img [ngClass]="metric.name" src="{{ '/assets/images/' + metric.name + '.png' }}" />
      </div>
    </div>
    <p
      class="comparison-note"
      *ngIf="metric.comparison_value > 0"
      [innerHtml]="'INSIGHTS.metrics.equivalent.' + metric.name | translate: { number: metric.comparison_value.toFixed(0) | thousand }"
    ></p>
    <ion-icon name="information-circle-outline"></ion-icon>
  </div>
</div>
